module.exports = __webpack_public_path__ + "static/img/14.00bb890.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/eng/14.png
// module id = BbDQ
// module chunks = 0